<template>
  <div class="cont-box" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <img class="title-header" src="../../assets/year-bg.png" />
    <div>
      <div class="list">
        <div class="title-cont">
          <img class="title-img" src="../../assets/b-title-des.png" />
          <p class="title">市场经营数据</p>
          <img class="title-img resever" src="../../assets/b-title-des.png" />
        </div>
        <Echart07M05 id="global04" :datas="data02" :items="items" :dimensions="dimensions" height="320px" />
      </div>
    </div>
    <NavStyleYear></NavStyleYear>
  </div>
</template>

<script>
  import Echart07M05 from '../../components/Echart07M05.vue'
  import NavStyleYear from '../../components/NavStyleYear.vue'
  
  export default {
    name: 'Year04',
    components: {
      Echart07M05,
      NavStyleYear
    },
    data() {
      return {
        loading: false,
        // items: [],
        // dimensions: ['name', 'firstYear', 'secondYear', 'thirdYear'],
        // data02: []
        items: ['中标剩余', '剩余确收转化比例', '合同', '确收', '回款', '费用'],
        dimensions: ['type', 'valueAll', 'valueRatio', 'value1', 'value2', 'value3', 'value4'],
        data02: [
          {type: "安徽", value1: 800, value2: 800, value3: 800, value4: 800, valueAll: 10000, valueRatio: 8}, 
          {type: "上海", value1: 400, value2: 400, value3: 400, value4: 400, valueAll: 10000, valueRatio: 4},
          {type: "浙江", value1: 300, value2: 300, value3: 300, value4: 300, valueAll: 10000, valueRatio: 5},
          // {type: "回款", value1: 10000, value2: 1000, value3: 10},
          // {type: "费用", value1: 10000, value2: 6000, value3: 60},
          // {type: "净利润", value1: 10000, value2: 5000, value3: 50},
        ].reverse()
      }
    },
    mounted() {
      // this.$axios.post('/annual_general/findList').then( res => {
      //   this.data02 = res.data.data.slice(0, 6)
      //   let obj = res.data.data[6]
      // this.items = [obj.firstYear, obj.secondYear, obj.thirdYear,]
      // })
    },
    methods: {

    }
  }
</script>

<style scoped>
  .cont-box {
    background-color: #08103c;
    min-height: 100%;
  }

  .title-header {
    width: 100%;
  }

  .resever {
    transform: scaleX(-1);
  }

  .title-cont {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .title-img {
    width: 80px;
  }

  .title {
    color: #2dfcff;
    font-size: 16px;
    font-weight: bold;
    padding: 0 10px;
    white-space: nowrap;
  }

  .list {
    padding-bottom: 40px;
  }
  
  .icon-list {
    padding: 0 0 10px;
    display: flex;
    justify-content: center;
    margin: -10px 0 40px;
  }
  .icon {
    width: 40%;
    background: rgba(0, 0, 0, .2);
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgba(45, 252, 255, .2);
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
    color: rgba(255, 255, 255, .6);
  }
  
  .icon-cur{
    color: white;
    background-color: #1fd6d9;
  }
  
  .title-cont01 {
    margin-bottom: 20px
  }
  .echart-box {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
  }
  .echart-box > div {
    width: 50%;
  }
  .time {
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, .6);
    font-size: 12px;
    padding: 6px;
  }
</style>
